<div role="group" aria-label="File Upload" class="flex flex-col">

  <div class="mb-5 ">
    <div role="heading" aria-level="6" class="body-default-regular">{{title}}</div>
    <div role="region" aria-label="File Upload Drop Zone" class="w-full p-5 mb-5 border-2 border-gray-500 border-dashed rounded-md"
      [class.drag-over]="isDragging" (dragover)="onDragOver($event)" (dragleave)="onDragLeave()"
      (drop)="onDrop($event)">

      <div class="flex flex-col items-center mb-2">
        <div class="text-4xl material-symbols-rounded">{{upload}}</div>
        <div class="body-large-bold">Drag and drop files upload</div>
        <div class="body-small-regular">Support files: {{accept}}</div>
      </div>

      <input type="file" (change)="onFileSelected($event)" class="mt-2 form-control" #fileInput hidden [accept]="accept" [multiple]="multiple">

      <button type="button" class="w-full btn btn-primary" (click)="fileInput.click()">
        <fa-icon [icon]="folderOpen"></fa-icon>Browse Files
      </button>
    </div>


    <div role="files-list" *ngFor="let file of files; let i = index" class="flex w-full p-5 mt-2 bg-white border border-gray-500 rounded-md">
      <div class="pt-4 material-symbols-rounded">{{draft}}</div>
      <div class="w-full pl-2 pr-2">
        <div class="body-default-bold"> {{file?.name}}</div>
        <div class="body-default-regular">{{convertByteToMegaByte(file?.size??0)?.toFixed(2)}} mb - <span *ngIf="!hasError[i]" class="text-green-500"> File upload complete  </span><span class="text-red-600" *ngIf="hasError[i]">File upload error. Supported format is {{accept}}, and maximum file size is 25 MB</span></div>
        <div [ngClass]="{'custom-progress-bar-error': hasError[i], 'custom-progress-bar-running': !hasError[i] && progress[i] != 0, 'custom-progress-bar-success': !hasError[i]}">
          <mat-progress-bar mode="determinate" value="{{progress[i]}}"
            ></mat-progress-bar>
        </div>
      </div>
      <div id="{{i}}" class="pt-4 cursor-pointer material-symbols-rounded" (click) = "onDelete($event)">{{close}}</div>
    </div>

  </div>
</div>
